import { doc, setDoc, writeBatch, collection } from 'firebase/firestore';
import { db } from './firebase';
import { 
    reportTitle, 
    ComplaintData, 
    trendData, 
    annualTrendData, 
    escalationData 
} from '../data/complaintsSeedData';

/**
 * Uploads the initial seed data to the 'legalPages/complaintsData' document in Firestore.
 * This is a one-time operation to populate the database.
 */
export const uploadInitialComplaintsData = async () => {
    const docRef = doc(db, 'legalPages', 'complaintsData');

    const fullData = {
        reportTitle,
        ComplaintData,
        trendData,
        annualTrendData,
        escalationData
    };

    try {
        await setDoc(docRef, fullData, { merge: true }); // Use merge to avoid overwriting if doc exists
        return { success: true, message: "Seed data uploaded successfully!" };
    } catch (error) {
        console.error("Error uploading initial data to Firestore:", error);
        return { success: false, message: `Upload failed: ${error.message}` };
    }
}; 